export default "__VITE_ASSET__CYfea2$k__"